var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { "justify-space-around": "" } },
        [
          _c(
            "v-flex",
            { attrs: { md10: "" } },
            [
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { staticClass: "headline mb-3" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            dark: "",
                            bottom: "",
                            right: "",
                            color: "primary",
                            title: "Input warehouse"
                          },
                          on: { click: _vm.showAddWarehouseDialog }
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("add")
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("site")) + "\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { staticClass: "subheading" },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-xs-left mr-2",
                      attrs: { xs12: "", md2: "", lg1: "" }
                    },
                    [_vm._v(_vm._s(_vm.$t("name")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-xs-left mr-2",
                      attrs: { xs12: "", md3: "", lg4: "" }
                    },
                    [_vm._v(_vm._s(_vm.$t("address")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-xs-left",
                      attrs: { xs12: "", md2: "", lg1: "" }
                    },
                    [_vm._v(_vm._s(_vm.$t("contact")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-xs-left",
                      attrs: { xs12: "", md2: "", lg1: "" }
                    },
                    [_vm._v(_vm._s(_vm.$t("phone")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-xs-center",
                      attrs: { xs12: "", md2: "" }
                    },
                    [_vm._v(_vm._s(_vm.$t("actions")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "mb-2" }),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { style: { overflow: "auto" } },
                    _vm._l(_vm.warehousesSites, function(item) {
                      return _c(
                        "v-layout",
                        {
                          key: item.key,
                          attrs: { row: "", wrap: "", "align-baseline": "" }
                        },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-left mr-2",
                              attrs: { xs12: "", md2: "", lg1: "" }
                            },
                            [_vm._v(_vm._s(item.name || item.siteName))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-left mr-2",
                              attrs: { xs12: "", md3: "", lg4: "" }
                            },
                            [
                              _c(
                                "p",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatAddress(
                                        item.address1,
                                        item.address2,
                                        item.city,
                                        item.state,
                                        item.zip
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-left",
                              attrs: { xs12: "", md2: "", lg1: "" }
                            },
                            [
                              _c(
                                "p",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(item.contact))]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-left",
                              attrs: { xs12: "", md2: "", lg1: "" }
                            },
                            [
                              _c(
                                "p",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(item.phone))]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-center",
                              attrs: { xs12: "", md2: "" }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        dark: "",
                                        color: "primary",
                                        flat: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.showEditWarehouseDialog(
                                            item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("edit")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        dark: "",
                                        color: "primary",
                                        flat: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.deleteAddressFunc(item)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("delete")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.addAddress
        ? _c("EditAddress", {
            attrs: {
              isWarehouse: "",
              siteNames: _vm.siteNames,
              actionFunc: _vm.addressSubmitted
            },
            model: {
              value: _vm.addAddress,
              callback: function($$v) {
                _vm.addAddress = $$v
              },
              expression: "addAddress"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editAddress
        ? _c("EditAddress", {
            attrs: {
              address: _vm.addressInEdit,
              isWarehouse: "",
              editMode: true,
              siteNames: _vm.siteNames,
              actionFunc: _vm.editAddressFunc,
              checkDistribution: function() {
                return _vm.$store.dispatch(
                  "checkWarehouseDistribution",
                  _vm.addressInEdit
                )
              }
            },
            model: {
              value: _vm.editAddress,
              callback: function($$v) {
                _vm.editAddress = $$v
              },
              expression: "editAddress"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec3dcd7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec3dcd7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Warehouse.vue
// module id = null
// module chunks = 